import { useEffect } from "react";
import { useImageExists } from "../../hooks/image";
import { IImageProps } from "../../interfaces/image";

export const Image = (props: IImageProps) => {
    useEffect(() => { }, [props])
    return useImageExists(props.src, props.alt, props.srcClassName, props.fallbackSrc, props.fallbackClassName, props.loadingIndicatorColor);
}